import React, { memo, useEffect, useState } from "react";
import { CarArrivalType } from "@Types/articles";
import cx from "classnames";
// import { article } from "@Api";
import { fetchNewlyListedCar } from "../../services/article_v2";
import ga from "@Lib/ga";
import { host } from "@Services/url";
import styles from "./articleIndex.module.less";

// const { fetchNewlyListedCar } = article;

const NewCarArrival: React.FC<any> = (params: { source: string }) => {
  const { source } = params;
  const [data, setData] = useState<CarArrivalType[]>([]);

  const fetchOil = async () => {
    const res = await fetchNewlyListedCar({
      limit: 15,
      type: "inquiry",
    });

    if (res && res.status === 12000) {
      setData(res.data.list);
    }
  };

  useEffect(() => {
    fetchOil();
  }, []);

  if (!data.length) {
    return null;
  }

  return (
    <div className={styles["new-car-up"]}>
      <div className={styles["title"]}>新車上市</div>
      <div className={styles["car-up-container"]}>
        {data.map((item, inx) => (
          <div
            className={cx(styles["item-wrapper"], {
              [styles["item-wrapper-discount"]]: item.isInquiry === 1,
            })}
            key={inx}
            onClick={() => {
              ga(["文章首頁", "其他", "新車上市"]);
              window.open(item.link, "_blank");
            }}
          >
            <div className={styles["item"]}>
              {!!item.discountPrice && <div className={styles["discount"]}>禮包{item.discountPrice}</div>}
              <div className={styles["top"]}>
                <span className={styles["time"]}>{item.date}</span>
                <span className={styles["tag"]}>{item.tag}</span>
              </div>
              <div className={styles["car-title-wrapper"]}>
                <div className={styles["car-title"]}>
                  {item.brandName} {item.kindName}
                </div>
              </div>
              <div className={styles["price"]}>{item.price}</div>
              <div
                className={styles["discount-btn"]}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  ga(["銷售線索", "文章-新車上市", "一鍵詢價"]);

                  window.open(
                    `${host.c}/ask/price?b=${item.brandId}&k=${item.kindId}&source=${source || "文章-新車上市"}`,
                    "_blank",
                  );
                }}
              >
                {!!item.discountPrice ? "詢優惠價" : "一鍵詢價"}
              </div>
              <img src={item.thumb} className={styles["thumb"]} width="146" height="96" style={{ aspectRatio: "146/96" }} alt={`${item.brandName} ${item.kindName}`} loading="lazy"/>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(NewCarArrival);
